<!-- Crossed-out original price, in Shopping Dollars (prices are loaded in Shopping Dollars). -->
<div class="price old-price breadcrumb" [class.inline]="inline()">
    @if (price()) {
        <p class="body-1">{{ price() | appDigitsGrouping }} {{ rewardName() }}</p>
    }
</div>
